import styled from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from '../../fields.constants';

export const Splash = styled.div`
  margin-bottom: ${em(14)};
  padding: ${em(11)} ${em(12)};
  font-size: ${rem(12.5)};
  line-height: 1.5;
  color: ${PALETTE.recordText};
  background: ${PALETTE.recordBg};
  border: ${em(1)} solid ${PALETTE.recordBorder};
  border-radius: ${em(6)};

  b {
    display: block;
    margin-bottom: ${em(2)};
    font-size: ${rem(13.5)};
    font-weight: 700;
  }
`;

export const Box = styled.div`
  padding: ${em(12)};
  background: ${PALETTE.panel};
  border: ${em(1)} solid ${PALETTE.line};
  border-radius: ${em(6)};
`;

export const Big = styled.div`
  font-size: ${rem(29)};
  font-weight: 500;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: ${PALETTE.ink};
`;

export const Caption = styled.div`
  margin-top: ${em(4)};
  font-size: ${rem(12.5)};
  color: ${PALETTE.muted};
`;

export const Rows = styled.div`
  margin-top: ${({ $compact }) => ($compact ? '12px' : em(14))};
`;

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${em(12)};
  padding: ${em(6)} 0;
  font-size: ${rem(12.5)};
  border-top: ${em(1)} solid ${PALETTE.line};

  &:first-child {
    border-top: none;
  }

  span {
    color: ${PALETTE.muted};
  }

  b {
    font-weight: 500;
    font-variant-numeric: tabular-nums;
    color: ${PALETTE.ink};
  }
`;

export const Section = styled.section`
  margin-bottom: 14px;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 10px;
  font-size: ${rem(15)};
  color: ${PALETTE.ink};
`;

export const Split = styled.div`
  display: flex;
  gap: 14px;
  margin-top: 8px;
  font-size: 12.5px;
  color: ${PALETTE.ink};
  font-variant-numeric: tabular-nums;
`;

export const SplitItem = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;

  i {
    display: block;
    width: 10px;
    height: 10px;
    background: ${({ $color }) => $color};
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
`;

export const AgainButton = styled.button`
  display: block;
  width: 100%;
  margin-top: 14px;
  padding: 10px;
  font-size: 14.5px;
  font-weight: 500;
  color: #fff;
  text-align: center;
  background: ${PALETTE.brand};
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${PALETTE.brandDark};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const Note = styled.p`
  margin: ${({ $first }) => ($first ? '0' : '10px 0 0')};
  font-size: 12px;
  line-height: 1.4;
  color: ${PALETTE.muted};
`;

export const ErrorNote = styled.p`
  margin: 8px 0 0;
  font-size: 12.5px;
  color: #b3261e;
`;
